import { ActionTypesClients } from './constants';
import { ClientDetailDataType, ClientFeatureData, ClientsInitialStateType, ContractedServicesType } from './types';

const initialState: ClientsInitialStateType = {
  clientsData: [] as any[],
  isClientsDataLoading: false,
  isClientDetailLoading: false,
  isServicesDataLoading: false,
  isClientFeeScheduleLoading: false,
  isAddFeeScheduleLoading: false,
  isTerminateFeeScheduleLoading: false,
  isClientFeatureLoading: false,
  clientDetailData: {} as ClientDetailDataType,
  allClientServices: [],
  clientFeeScheduleData: [],
  clientFeatureList: [],
  clientDetailsData: [],
  isClientDetailsLoading: false,
};

function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypesClients.SET_CLIENTS_DATA:
      return {
        ...state,
        clientsData: action.gridData,
      };
    case ActionTypesClients.SET_CLIENT_DETAIL_DATA:
      return {
        ...state,
        clientDetailData: action.response,
      };
    case ActionTypesClients.SET_ALL_CLIENT_SERVICES:
      return {
        ...state,
        allClientServices: action.response,
      };
    case ActionTypesClients.TOGGLE_IS_CLIENTS_DATA_LOADING:
      return {
        ...state,
        isClientsDataLoading: action.isLoading,
      };
    case ActionTypesClients.TOGGLE_IS_CLIENT_DETAIL_LOADING:
      return {
        ...state,
        isClientDetailLoading: action.isLoading,
      };
    case ActionTypesClients.TOGGLE_IS_ADD_FEE_SCHEDULE_LOADING:
      return {
        ...state,
        isAddFeeScheduleLoading: action.isLoading,
      };
    case ActionTypesClients.TOGGLE_IS_TERMINATE_FEE_SCHEDULE_LOADING:
      return {
        ...state,
        isTerminateFeeScheduleLoading: action.isLoading,
      };
    case ActionTypesClients.TOGGLE_IS_CLIENT_FEE_SCHEDULE_LOADING:
      return {
        ...state,
        isClientFeeScheduleLoading: action.isLoading,
      };
    case ActionTypesClients.TOGGLE_IS_SERVICES_DATA_LOADING:
      return {
        ...state,
        isServicesDataLoading: action.isLoading,
      };
    case ActionTypesClients.CLEAR_CLIENT_DETAIL_PANE_REDUX_DATA:
      return {
        ...state,
        clientDetailData: {} as ClientDetailDataType,
        isClientDetailLoading: false,
      };
    case ActionTypesClients.SET_CLIENT_FEE_SCHEDULE_DATA:
      return {
        ...state,
        clientFeeScheduleData: action.data,
      };
    case ActionTypesClients.SET_CLIENT_FEATURE_DATA:
      return {
        ...state,
        clientFeatureList: action.data,
      };
    case ActionTypesClients.TOGGLE_IS_CLIENT_FEATURE_LOADING:
      return {
        ...state,
        isClientFeatureLoading: action.isLoading,
      };
    case ActionTypesClients.SET_CLIENT_DETAILS_DATA:
      return {
        ...state,
        clientDetailsData: action.data,
      };
    case ActionTypesClients.TOGGLE_IS_CLIENT_DETAILS_LOADING:
      return {
        ...state,
        isClientDetailsLoading: action.isLoading,
      };
    default:
      return state;
  }
}

export default clientsReducer;
